<template>
    <div class="sales-card-location">
        <div class="sales-card-section-title">
            <h2>{{ salesCardArr.project_page_in.location_title  }}</h2>
            <p v-html="salesCardArr.project_page_in.location_desc"></p>
        </div>
        <div class="location-main-places">
            <div class="plcae-item" v-for="item in salesCardArr.project_page_in.location_main_places">
                <div class="time">
                    <strong>{{ item.time }}</strong>
                    <span>{{ salesCardArr.project_page_in.location_place_minute }}</span>
                </div>
                <div class="info">
                    <strong>{{ item.name }}</strong>
                    <span>{{ item.type }}</span>
                </div>
            </div>
        </div>
        <div class="mobile-on-map-btn" v-if="isMobileChecker">
            <img :src="salesCardArr.project_page_in.location_map_mobile_img" alt="">
            <div class="map-btn-title" @click="openMobileMapSet">
                <svgIcon name="pin"/>
                <span>{{ salesCardArr.project_page_in.location_map_mobile_btn_name }}</span>
            </div>
        </div>
        <div class="column-container">
            <div class="col-left" :class="{'openFilterMobile' : openFilterMobile}">
                <div class="location-map-filter">
                    <h3>{{ salesCardArr.project_page_in.location_map_pins.pins_title }}</h3>
                    <div class="filter-btns">
                        <div class="item-check-pin">
                            <div class="item-icon">
                                <img :src="salesCardArr.project_page_in.location_map_pins.btn_all_category.marker" alt="">
                            </div>
                            <input type="checkbox" :id="'pin_category_all'" :value="'all'"  v-model="pinsCategoryCheckedAll" @change="pinsCategoryChecked = [], getFilteredPins()"> 
                            <label :for="'pin_category_all'">{{ salesCardArr.project_page_in.location_map_pins.btn_all_category.name }}</label>
                            <span>{{ allPinsCount }}</span>
                        </div>
                        <div class="item-check-pin" v-for="item in salesCardArr.project_page_in.location_map_pins.category">
                            <!-- @change="filterSalesItems()" -->
                            <div class="item-icon">
                                <img :src="item.marker" alt="">
                            </div>
                            <input type="checkbox" :id="'pin_category_' + item.name" :value="item.name" v-model="pinsCategoryChecked" @change="pinsCategoryCheckedAll = false, getFilteredPins()"> 
                            <label :for="'pin_category_' + item.name">{{item.name}}</label>
                            <span>{{ item.piins.length }}</span>
                        </div>
                    </div>
                    <!-- MOBILE -->
                    <div class="mobile-filter-header" v-if="isMobileChecker">
                        <h2><span>Фильтр</span></h2>
                        <a href="#" class="close-link" @click.prevent="openFilterMobile = false"><svgIcon name="close" class="icon-svg"/></a>
                    </div>
                    <div class="mobile-filter-btn-look" v-if="isMobileChecker">
                        <a href="#" @click.prevent="openFilterMobile = false">Показать <span>{{ pinsItems.length }}</span> объектов</a>
                    </div>
                    <!-- END MOBILE -->
                </div>
            </div>
            <div class="col-right" :class="{'openMobile' : openMapMobile}">
                <div class="location-map-container">
                    <div class="map salesCardMap" id="salesCardMap" :class="{'map-lock' : lockMap}"></div>
                    <a href="#" class="unlock-map-btn" @click.prevent="lockMap = !lockMap" :class="{'unlock-link' : !lockMap}">
                        <div class="link-in">
                            <div class="icon-item">
                                <svgIcon name="lock" class="icon-lock" :class="{'hide' : !lockMap}"/>
                                <svgIcon name="unlock" class="icon-unlock" :class="{'show' : !lockMap}"/>
                            </div>
                            <span :class="{'unlock' : !lockMap}">Разблокировать карту</span>
                        </div>
                    </a>
                    <a href="#" class="filter-map-mobile" @click.prevent="openFilterMobile = !openFilterMobile" v-if="isMobileChecker">
                        <svgIcon name="filter"/>
                        <span>Фильтр</span>
                    </a>
                    <a href="#" class="close-map-mobile" @click.prevent="closeMapMobile" v-if="isMobileChecker">
                        <svgIcon name="close"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'sales-card-location',
        props: ['salesCardArr'],
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                openMapMobile: false,
                openFilterMobile: false,
                lockMap: false,
                zoom: 13,
                offsetHorizontal: 100,
                offsetVertical: 135,
                allPinsCount: 1,
                pinsCategoryChecked: [],
                pinsCategoryCheckedAll: true,
                pinsItems: [],
                Ymap: null,
            }
        },
        computed: mapGetters({
            // indexPage: 'loadIndexPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            initMap() {
                this.$loadScript("https://api-maps.yandex.ru/2.1/?apikey=e684e26f-c03a-4724-9b73-bca23bfbccaf&lang=ru_RU")
                .then(() => {
                    if (this.salesCardArr.project_page_in != null && this.salesCardArr.project_page_in.location_menu.init) {
                        var lat_project = parseFloat(this.salesCardArr.project_page_in.project_map_lat),
                            lng_project = parseFloat(this.salesCardArr.project_page_in.project_map_lng);
                        var _self = this;
                        var zoom = this.zoom;
                        var offset_horizontal = this.offsetHorizontal;
                        var offset_vertical = this.offsetVertical;
                        var i;
                        var Ymap;
                        var clusterer;
                        ymaps.ready().then(function() {
                            var initMap = function() {
                                Ymap = new ymaps.Map('salesCardMap', {
                                    center: [lat_project, lng_project],
                                    zoom: zoom,
                                    controls: [],
                                    behaviors: ["drag", "rightMouseButtonMagnifier", "multiTouch", "scrollZoom"]
                                },{suppressMapOpenBlock: false, minZoom: 11, maxZoom: 18, yandexMapDisablePoiInteractivity: true});
                                var btnZoomInLayout = ymaps.templateLayoutFactory.createClass(
                                    '<button class="btn-zoom-in ymap-home-btn-zoom"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13 11V5H11V11H5V13H11V19H13V13H19V11H13Z"></path></svg></button>'
                                );
                                var btnZoomOutLayout = ymaps.templateLayoutFactory.createClass(
                                    '<button class="btn-zoom-out ymap-home-btn-zoom"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5 11V13L19 13V11L5 11Z"></path></svg></button>'
                                );
                                var zoomInButton = new ymaps.control.Button({
                                    data: { content: '' },
                                    options: { selectOnClick: false, layout: btnZoomInLayout }
                                });
                                var zoomOutButton = new ymaps.control.Button({
                                    data: { content: '-' },
                                    options: { selectOnClick: false, layout: btnZoomOutLayout }
                                });
                                zoomInButton.events.add('click', function () {
                                    Ymap.setZoom(Ymap.getZoom() + 1, { duration: 300, checkZoomRange: true });
                                });
                                zoomOutButton.events.add('click', function () {
                                    Ymap.setZoom(Ymap.getZoom() - 1, { duration: 300, checkZoomRange: true });
                                });
                                Ymap.controls.add(zoomInButton, { float: 'none', position: { top: 170, right: 20 } });
                                Ymap.controls.add(zoomOutButton, { float: 'none', position: { top: 225, right: 20 } });
                            };

                            var buildMainPin = function() {
                                const customLayout = ymaps.templateLayoutFactory.createClass(
                                    '<div class="yandex-dial-point" style="width: $[properties.iconWidth]px; height: $[properties.iconHeight]px;">'+ 
                                        '<div class="point-layout">' +
                                            '<div class="marker-img">'+ 
                                                '<div class="img-in">' +
                                                    '<img src="' + _self.salesCardArr.project_page_in.location_map_marker + '"/>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>'
                                );
                                const myPlacemark = new ymaps.Placemark([lat_project, lng_project], 
                                    {
                                        hintContent: '',
                                        balloonContent: "",
                                    },
                                    {
                                        preset: "islands#circleDotIcon",
                                        iconLayout: customLayout,
                                        iconImageSize: [8, 8],
                                        iconImageOffset: [-4, -8],
                                        zIndex: 731,
                                        zIndexActive: 735,
                                        zIndexHover: 734,
                                        iconPane: "overlaps",
                                    }
                                );
                                Ymap.geoObjects.add(myPlacemark);
                            };

                            var buildClasterOnMap = function () {
                                const PinsItems = _self.pinsItems;
                                
                                clusterer = new ymaps.Clusterer({
                                    clusterIcons: [{
                                        size: [32, 32],
                                        offset: [-32, -32]
                                    }],
                                    clusterBalloonContentLayout: null,
                                    groupByCoordinates: !1,
                                    clusterDisableClickZoom: !1,
                                    clusterHideIconOnBalloonOpen: !1,
                                    geoObjectHideIconOnBalloonOpen: !1,
                                    clusterIconContentLayout: ymaps.templateLayoutFactory.createClass('{% if properties.geoObjects.length> 9 %}<div class="d-map-infra-cluster">9+</div>{% else %}<div class="d-map-infra-cluster">{{ properties.geoObjects.length }}</div>{% endif %}')
                                });

                                for (var i=0; i < PinsItems.length; i++) {
                                    const customLayout = ymaps.templateLayoutFactory.createClass(
                                        '<div class="yandex-pin-point">'+ 
                                            '<div class="point-layout">' +
                                                '<div class="marker-img">'+ 
                                                    '<img src="' + PinsItems[i].marker + '"/>' +
                                                '</div>' +
                                                '<div class="marker-info">' +
                                                    '<p>' + PinsItems[i].name + '</p>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>'
                                    );

                                    const myPlacemark_pin = new ymaps.Placemark([PinsItems[i].lat, PinsItems[i].lng], 
                                        {
                                            hintContent: '',
                                            balloonContent: "",
                                        },
                                        {
                                            preset: "islands#circleDotIcon",
                                            iconLayout: customLayout,
                                            iconImageSize: [8, 8],
                                            iconImageOffset: [-4, -8],
                                            zIndex: 730,
                                            zIndexActive: 732,
                                            zIndexHover: 731,
                                            iconPane: "overlaps",
                                        }
                                    );
                                    clusterer.add(myPlacemark_pin);
                                }
                                Ymap.geoObjects.add(clusterer);
                            }

                            var removeAllClusterer = function () {
                                clusterer.removeAll();
                            };

                            var clicker = function() {
                                $('.item-check-pin label').on('click', function() {
                                    removeAllClusterer();
                                    setTimeout(() => {
                                        buildClasterOnMap();
                                    }, 50)
                                });
                            }

                            initMap();
                            buildMainPin();
                            buildClasterOnMap();
                            clicker();
                        });
                    }
                });
            },
            getFilteredPins() {
                const defaultItems = this.salesCardArr.project_page_in.location_map_pins.category;
                if (!this.pinsCategoryCheckedAll) {
                    const filteredData = defaultItems.filter(item => {
                        return this.pinsCategoryChecked.includes(item.name)
                    });
                    if (filteredData.length > 0) {
                        this.setPinsItems(filteredData, 'filter');
                    } else {
                        this.pinsCategoryCheckedAll = true
                        this.setPinsItems(defaultItems, 'filter');
                    }
                } else {
                    this.setPinsItems(defaultItems, 'filter');
                }
            },  
            setPinsItems(arr, param) {
                this.pinsItems = [];
                const pinsLoopItems = [];
                for (var i=0; i < arr.length; i++) {
                    for (var p=0; p < arr[i].piins.length; p++) {
                        pinsLoopItems.push(Object.assign(arr[i].piins[p], {
                            marker: arr[i].marker,
                        }));
                    }
                } 
                if (param == 'filter') {
                    this.pinsItems = pinsLoopItems;
                    // console.log(this.pinsItems)
                } else {
                    this.allPinsCount = pinsLoopItems.length;
                }
            },
            openMobileMapSet() {
                this.openMapMobile = true;
                this.lockMap = false;
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                document.getElementById('header').classList.add('hideMobile');

            },
            closeMapMobile() {
                this.openMapMobile = false;
                this.lockMap = true;
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementById('header').classList.remove('hideMobile');
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
            this.setPinsItems(this.salesCardArr.project_page_in.location_map_pins.category, 'default');
            this.getFilteredPins();
            this.initMap();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-card/sales-card-location.scss';
    @import '@/styles/components/sales-card/respond/sales-card-location-respond.scss';
    // @import '@/styles/components/sales-card/respond/sales-card-about-respond.scss';
</style>